import FinishedGameDetailsCard from "./finshedGameDetailsCard.molecule";

export default FinishedGameDetailsCard;
